/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A locked lock icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function LockOpenedIcon({ className, size = 'small' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 20 20" },
        jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            jsx("g", { fill: "currentColor", fillRule: "nonzero", transform: "translate(-879 -2117)" },
                jsx("path", { d: "M5 10v7h9v-7H5zm1-1V5.5a3.5 3.5 0 017 0v.534h-1V5.5a2.5 2.5 0 10-5 0V9h7.5a.5.5 0 01.5.5v8a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5H6zm3 4.866V15a.5.5 0 101 0v-1.134a1 1 0 10-1 0z", transform: "translate(879 2117)" })))));
}
//# sourceMappingURL=LockOpenedIcon.js.map